/** 企业资料弹窗随内容自适应；80vh 上限、滚动与固定操作区由全局 ConfigProvider 管理。 */
export const enterpriseModalProps = {
  centered: true
}
